import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate',
})
export class TruncatePipe implements PipeTransform {

  // Allow the input value to be a string OR undefined
  transform(value: string | undefined, limit: number = 50, ellipsis: string = '...'): string {
    if (!value) {
      return '';
    }
    
    return value.length > limit ? value.substring(0, limit) + ellipsis : value;
  }

}
